/* eslint-disable import/no-anonymous-default-export */

import { useContext, useState } from "react";
import styled from "styled-components";
import { LoginData } from '../useUsuariosAPI';
import { Form, Input, message, Button } from 'antd';
import UsuariosContext from '../../common/contexts/UsuariosContext';
import { useNavigate } from "react-router-dom";
import BrandBar from "../../common/components/BrandBar";

const LoginCard = styled.div`
padding: 1rem;
background: #f5f5f5;
z-index:1;
`;

const StyledLoginLayout = styled.div`
background:url('login-background.jpg');
position:relative;
&::before
{
    content:'';
    background-color:rgba(0,0,0,0.6);
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
}
& > div
{
    z-index:1;
    width: 90%;
    margin: auto;
    max-width: 300px;
    box-shadow: rgb(99 99 99 / 20%) 0px 2px 8px 0px;
}
height:100vh;
display:flex;
align-items:center;
`;


export default () => {
    const context = useContext(UsuariosContext);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    async function onLogin(loginData: LoginData) {
        setLoading(true);

        var data = await context.signIn(loginData);
        if (data) {
            switch (data.rol.nombre) {
                case "Renombrador":
                    navigate("/lotes-renombrado/renombrar")
                    break;
                case "Juzgado":
                    navigate("/juzgado-consulta" )
                    break;
                case "Cobranzas":
                    navigate("/juzgado-consulta" )
                    break;
                case "Visor graficas":
                    navigate("/dashboard")
                    break;
                default:
                    navigate("/")   
                    break;
            }
            return;
        }

        message.error({
            content: 'Datos incorrectos'
        });

        setLoading(false);



    }

    return (
        <StyledLoginLayout>
            <div>
                <BrandBar style={{padding:'1rem'}}  />
                <LoginCard>
                    <Form
                        onFinish={onLogin}
                        layout="vertical">
                        <Form.Item
                            name={"NombreUsuario"}
                            label="Nombre de usuario"
                            rules={[{ required: true, message: "Ingrese el nombre de usuario" }]}
                        >

                            <Input />
                        </Form.Item>
                        <Form.Item
                            name={"Contrasena"}
                            label="Contraseña"
                            rules={[{ required: true, message: "Ingrese la contraseña" }]}

                        >
                            <Input.Password />
                        </Form.Item>
                        <Form.Item style={{ marginBottom: 0, marginTop: 10 }}>
                            <Button loading={loading} type="primary" htmlType="submit">Ingresar</Button>
                        </Form.Item>
                    </Form>
                </LoginCard>
            </div>
        </StyledLoginLayout>
    );
}